import RequestUtility from './request';

const SERVICE_URL =
  window.location.hostname === 'www.getfoodfight.link'
    ? 'https://d2if4tc6g5.execute-api.us-east-1.amazonaws.com/prod'
    : 'https://v5j4xszs7i.execute-api.us-east-1.amazonaws.com/prod';

const util = new RequestUtility(SERVICE_URL);

/**
 * Fetches prize offers for the current user.
 * @param {string} bearerToken
 * @returns {Promise<PrizeOfferListResponse>}
 */

async function fetchUserPrizeOffers(bearerToken) {
  const response = await util.authorizedRequest('prize_offers/user/~', {
    method: 'GET',
    bearerToken,
  });
  return response;
}

async function fetchUserLimitPrizeOffers(bearerToken, limit, offset, status) {
  const response = await util.authorizedRequest(
    `/prize_offers/user/paginated?limit=${limit}&offset=${offset}&status=${status}`,
    {
      method: 'GET',
      bearerToken,
    },
  );
  return response;
}

async function redeemPrizeOffer(bearerToken, offer) {
  const response = await util.authorizedRequest(
    `prize_offers/${offer.id}/redeem`,
    {
      method: 'POST',
      bearerToken,
    },
    {
      security_code: offer.security_code,
    },
  );
  return response;
}

export async function fetchUserPrizeOffersDetailed(bearerToken, userId) {
  if (!userId || userId === 'Unset value') {
    throw new Error('User ID is required');
  }
  const response = await util.authorizedRequest(`prize_offers/user/${userId}`, {
    method: 'GET',
    bearerToken,
  });
  return response;
}

export async function fetchPrizeOfferDetail(bearerToken, offerId) {
  const response = await util.authorizedRequest(`prize_offers/${offerId}`, {
    method: 'GET',
    bearerToken,
  });

  if (!response?.success || !response.offer) {
    throw new Error(`Failed to fetch offer ${offerId}`);
  }

  return response.offer;
}

const exports = {
  fetchUserPrizeOffers,
  fetchUserLimitPrizeOffers,
  redeemPrizeOffer,
};

export { fetchUserPrizeOffers, fetchUserLimitPrizeOffers, redeemPrizeOffer };
export default exports;
